import { IPaginationResourceShort } from '../../props/general';
import { IVesselCrewResourceProps, IVesselCrewResourceShortProps } from '../../props/vessels/crew';
import Request from '../request';

const VesselCrewService = {
  retrieve: async (vesselId: string, qs?: string): Promise<{ data: IVesselCrewResourceShortProps[], pagination: IPaginationResourceShort }> => {
    try {
      const results = await Request.get(`/api/vessels/${vesselId}/crews?${qs || ''}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  read: async (vesselId: string, id: string): Promise<IVesselCrewResourceProps> => {
    try {
      const results = await Request.get(`/api/vessels/${vesselId}/crews/${id}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  create: async (vesselId: string, data: FormData): Promise<IVesselCrewResourceProps> => {
    try {
      const result = await Request.post(`/api/vessels/${vesselId}/crews`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  },
  update: async (vesselId: string, id: string, data: FormData): Promise<IVesselCrewResourceProps> => {
    try {
      const result = await Request.post(`/api/vessels/${vesselId}/crews/${id}?_method=PUT`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  },
  deactivate: async (vesselId: string, id: string, data: FormData): Promise<IVesselCrewResourceProps> => {
    try {
      const result = await Request.post(`/api/vessels/${vesselId}/crews/${id}/deactivate`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  }
};

export default VesselCrewService;
